import { useTranslation } from 'react-i18next';
import {
  BlueSubtleSection,
  CardGrid,
  Overline,
  SectionHeader,
  SectionHeading,
  SectionInner,
} from '../HostfullyAccountingMarketing.styles';
import { FEATURE_CARDS } from '../HostfullyAccounting.constants';
import MarketingContentCard from './MarketingContentCard';

const FeaturesSection = () => {
  const { t } = useTranslation();

  return (
    <BlueSubtleSection data-testid="marketing-features">
      <SectionInner>
        <SectionHeader>
          <Overline>
            {t('pageHostfullyAccounting.marketing.features.overline')}
          </Overline>
          <SectionHeading>
            {t('pageHostfullyAccounting.marketing.features.title')}
          </SectionHeading>
        </SectionHeader>
        <CardGrid $columns={2}>
          {FEATURE_CARDS.map((card) => (
            <MarketingContentCard key={card.testId} card={card} />
          ))}
        </CardGrid>
      </SectionInner>
    </BlueSubtleSection>
  );
};

export default FeaturesSection;
